import React from 'react';
import s from '../../../PersonalOffice/MyOrders/MyOrdersPopups/Edit/PopupManagerEdit.module.css';
import {OnePaymentType} from '../../../types/TypesUserOrders';
import NewInfoCheckbox from '../../../PersonalOffice/MyOrders/MyOrdersPopups/InfoCheckBox/NewInfoCheckbox';
import style from '../../../PersonalOffice/MyOrders/MyOrdersPopups/PopupsCommonStyle.module.css';
import {useFormikContext} from 'formik';
import {useGetOrderServiceListQuery} from '../../../redux/DepotSlice/depotOrdersApi';
import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store';
import PreLoaderComponent from '../../../assets/Animations/PreLoaderComponent/PreLoaderComponent';

const PayTypeSelector: React.FC = () => {
	const {setFieldValue, values, status} = useFormikContext();
	const user = useSelector((state: RootState) => state.userData.userView);
	const {data: orderService, isLoading} = useGetOrderServiceListQuery(
		user?.location ?? '',
	);
	if (isLoading) {
		return <PreLoaderComponent type={'gallery'} size={'big'} />;
	} else {
		return (
			<ul className={s.checkboxList}>
				{orderService &&
					orderService?.payment_types.map((payment: OnePaymentType) => {
						return (
							<li key={payment.payment_type} className={s.checkboxElement}>
								<NewInfoCheckbox
									id={payment.payment_type}
									setFieldValue={setFieldValue}
									valueName={'payment_method'}
									labelTxt={payment.payment_name}
									values={values}
								/>
							</li>
						);
					})}
				{status && status.payment_method && (
					<span className={style.error}>ОШИБКА!</span>
				)}
			</ul>
		);
	}
};

export default PayTypeSelector;
